export const BuildInfo = {timestamp:1771263732000}
